import wtcSvg from "../../assets/cricket-quiz.jpg";
import iplSvg from "../../assets/iplSvg.jpg";

export const quizQuestions = [
	{
		category: "World Test Championship 2021 Quiz",
		categoryImg: wtcSvg,
		questions: [
			{
				question: "Which team lost most Tests in the first cycle of the WTC?",
				answer: "South Africa",
				options: [
					{
						option: "England",
					},
					{
						option: "Sri lanka",
					},
					{
						option: "South Africa",
					},
					{
						option: "Bangladesh",
					},
				],
			},
			{
				question:
					"Who was the only player to be dismissed for 199 during the first edition of the WTC?",
				answer: "Faf du plessis",
				options: [
					{
						option: "Faf du plessis",
					},
					{
						option: "Joe Root",
					},
					{
						option: "Marnus Labuschagne",
					},
					{
						option: "Henry Nicholls",
					},
				],
			},
			{
				question:
					"Who has bowled the most number of balls in the first season of the WTC?",
				answer: "Nathan Lyon",
				options: [
					{
						option: "Ravichandran Ashwin",
					},
					{
						option: "Stuart Broad",
					},
					{
						option: "Pat Cummins",
					},
					{
						option: "Nathan Lyon",
					},
				],
			},
			{
				question:
					"Which cricketer won the most Player of the Match awards in the first WTC cycle?",
				answer: "Ben Stokes",
				options: [
					{
						option: "Steve smith",
					},
					{
						option: "Ravichandran Ashwin",
					},
					{
						option: "Joe Root",
					},
					{
						option: "Ben Stokes",
					},
				],
			},
			{
				question:
					"Which player scored 28 runs off an over from Joe Root – a joint world record for most runs in an over in Tests?",
				answer: "Keshav Maharaj",
				options: [
					{
						option: "Rishabh Pant",
					},
					{
						option: "Colin de Grandhomme",
					},
					{
						option: "Keshav Maharaj",
					},
					{
						option: "None of the above",
					},
				],
			},
		],
	},
	{
		category: "IPL Quiz",
		categoryImg: iplSvg,
		questions: [
			{
				question: "Who scored first century of IPL tournaments",
				answer: "Brendon McCullum",
				options: [
					{
						option: "Saurav Ganguly",
					},
					{
						option: "Brendon McCullum",
					},
					{
						option: "Manish Pandey",
					},
					{
						option: "Suresh Raina",
					},
				],
			},
			{
				question: "Who was the first indian captain to hold IPL trophy",
				answer: "M.S Dhoni",
				options: [
					{
						option: "Anil Kumble",
					},
					{
						option: "M.S Dhoni",
					},
					{
						option: "Sachin Tendulkar",
					},
					{
						option: "Gautam Gambhir",
					},
				],
			},
			{
				question: "Who took first hattrick in IPL match",
				answer: "Laxmipathy Balaji",
				options: [
					{
						option: "Laxmipathy Balaji",
					},
					{
						option: "Yuvraj Singh",
					},
					{
						option: "Irfan Pathan",
					},
					{
						option: "Anil Kumble",
					},
				],
			},
			{
				question: "Where was the first IPL match played",
				answer: "Bangalore",
				options: [
					{
						option: "Mumbai",
					},
					{
						option: "Bangalore",
					},
					{
						option: "Kolkata",
					},
					{
						option: "Mohali",
					},
				],
			},
			{
				question: "Who has scored most runs in IPL tournaments",
				answer: "Virat Kohli",
				options: [
					{
						option: "Suresh Raina",
					},
					{
						option: "David Warner",
					},
					{
						option: "Virat Kohli",
					},
					{
						option: "Rohit Sharma",
					},
				],
			},
		],
	},
];
